'use client';
import type { CSSProperties, ReactElement, ReactNode } from 'react';
import { Ccontainer } from '../Ccontainer';
import { Cscrollable } from '../Cscrollable/Cscrollable';
import { Cmarkdown } from '../Cmarkdown/Cmarkdown';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { SCROLL_DIRECTION_VERTICAL, TEXT_ALIGN_CENTER, } from './messageModalConstants';
const CUSTOM_CONTENT_VALUE = "custom-content";
interface MessageModalContentAreaProps {
    body?: string;
    children?: ReactNode;
    dataElScope: DataElScope;
    contentAreaHeight?: string;
    contentAreaStyle?: CSSProperties;
}
export function MessageModalContentArea({ body, children, dataElScope, contentAreaHeight, contentAreaStyle, }: MessageModalContentAreaProps): ReactElement {
    return (
      <Ccontainer width="100%" height={contentAreaHeight} padding={0} backgroundColor={ColorType.Transparent} style={contentAreaStyle}>
        <Cscrollable dataElScope={dataElScope} direction={SCROLL_DIRECTION_VERTICAL} fadeSize={20}>
          <div data-el={dataEl(dataElScope, 'ContentArea/Content')} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            alignItems: 'center',
            paddingBottom: '20px',
        }}>
            {body && (<div data-el={dataEl(dataElScope, 'ContentArea/Body')} style={{ width: '100%', marginTop: '20px', textAlign: 'center' }}>
                <Cmarkdown content={body} alignItems="center" textAlign={TEXT_ALIGN_CENTER} textSize={18} textWeight={FontWeight.Medium}/>
              </div>)}
            {children && <div data-el={dataEl(dataElScope, 'ContentArea/CustomContent')}>{children}</div>}
          </div>
        </Cscrollable>
      </Ccontainer>
    );
}
